/**
 * Cas particuliers — création optimisée (Lot UI-A).
 */

import ProduitSectionHeader from './ProduitSectionHeader.jsx';

const SHORTCUTS = [
  {
    id: 'plateau',
    label: 'Plateau à composer (par pièces)',
    hint: 'Sushi, plateau par pièces',
    isActive: (formData) => Boolean(formData.modeComposition),
  },
  {
    id: 'planche',
    label: 'Planche traiteur (par personnes)',
    hint: 'Il Piatto, planches tapas',
    isActive: (formData) => Boolean(formData.isPlateauParPersonne),
  },
  {
    id: 'poids',
    label: 'Vente au poids / à la coupe',
    hint: 'Charcuterie, fromage au kg',
    isActive: (formData) => Boolean(formData.venteAuPoids),
  },
];

export default function ProduitCasParticuliers({
  formData,
  showAllSections,
  onShortcutToggle,
  onShowAllSections,
  onShowSimplified,
}) {
  return (
    <div className="rounded-xl border border-sky-200 bg-sky-50/60 p-5 space-y-4">
      <ProduitSectionHeader title="Cas particuliers" helpKey="casParticuliers" />

      {!showAllSections ? (
        <>
          <div className="space-y-2">
            {SHORTCUTS.map((s) => (
              <label
                key={s.id}
                className="flex items-start gap-3 p-3 rounded-lg border border-sky-100 bg-white cursor-pointer hover:border-sky-300 transition"
              >
                <input
                  type="checkbox"
                  checked={s.isActive(formData)}
                  onChange={(e) => onShortcutToggle(s.id, e.target.checked)}
                  className="mt-0.5 h-4 w-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
                />
                <span className="min-w-0">
                  <span className="block text-sm font-medium text-gray-900">{s.label}</span>
                  <span className="block text-xs text-gray-500 mt-0.5">{s.hint}</span>
                </span>
              </label>
            ))}
          </div>
          <button
            type="button"
            onClick={onShowAllSections}
            className="text-sm text-gray-600 hover:text-gray-900 underline"
          >
            Afficher toutes les sections
          </button>
        </>
      ) : (
        <button
          type="button"
          onClick={onShowSimplified}
          className="text-sm text-primary-700 hover:text-primary-900 font-medium"
        >
          Revenir au mode simplifié
        </button>
      )}
    </div>
  );
}
